import {skipToken, SkipToken} from '@reduxjs/toolkit/query';

import {useState} from 'react';

import {isNotNil} from 'ramda';

import {useOnMount} from 'shared/web';

import {priceReportApi} from '../../../store/priceReportApi';
import {GetStatisticsV2ApiArg} from '../../../types/api/api';

/**
 * Releases the statistics query arg after a small per-row delay, so expanding the
 * panel ramps its requests up instead of firing one burst per saved filter — the
 * rows still load progressively (each shows its skeleton meanwhile) and the last
 * row starts only a moment later. Rows whose result is already cached skip the
 * delay entirely, so a re-expanded panel renders instantly.
 */
export function useStaggeredQueryArg(
  queryArg: GetStatisticsV2ApiArg | SkipToken,
  delayMs: number
): GetStatisticsV2ApiArg | SkipToken {
  const [isReleased, setIsReleased] = useState(delayMs <= 0);

  // Peeks at the cache without subscribing — a cached row must not wait.
  const {data: cachedData} = priceReportApi.endpoints.getStatisticsV2.useQueryState(queryArg);

  useOnMount(() => {
    setTimeout(() => setIsReleased(true), delayMs);
  });

  if (queryArg === skipToken) {
    return skipToken;
  }
  return isReleased || isNotNil(cachedData) ? queryArg : skipToken;
}
